import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import appRouterService from '@/services/route/appRouterService';
import {selectAutoStart} from '@/state/selectors/deviceSettings';

import {createSwitchSetting} from '../../components/SwitchSetting';

export const createAutoStartSetting = () =>
    createSwitchSetting({
        settingType: AEM_DEVICE_SETTINGS_TYPES.AUTO_START,
        selector: selectAutoStart,
        onNavigate: () => appRouterService.forwardToAutoStartPage(),
    });
